<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 3" :class="{active: num == 3}">wh9介绍</li>
            <li @click="num = 0" :class="{active: num == 0}">wh9宽语言简介</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        
        <div class="details_gn" v-show="num == 3">
            <p class="intent">
                库安算法交易软件wh9，是文华财经旗下的一款算法交易软件，针对机构和量化团队，聚焦盘口算法模型开发、回测和自动交易，支持期货、期权的各种复杂交易，也支持算法组件附加到手动交易、趋势量化策略的执行过程中，进行精细化控制，根据盘口行情智能拆单，降低冲击成本，提高交易效率。                
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 0">
            <p>
                宽语言是一种类C语言的计算机特殊金融编程语言：<br />
                · 类C语言的语法和运行逻辑，编写可以随心所欲，实现各类复杂逻辑的策略开发；<br />
                · 编译的运行模式使公式运行速度更快，可接近C语言的运行速度；<br />
                · 强大的科学计算及数据处理能力，能将交易思路转化为自定义用户函数和公式应用等计算机语言。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">9B套餐量化交易</p>
            <p class="tent">1.类C语言的语法和运行逻辑，编译运行模式使公式运行速度更快，可接近C语言的运行速度。</p>
            <p class="tent">2.支持自定义函数：可创建自定义函数，支持各类复杂逻辑的交易策略开发，能够自由实现各类复杂的算法交易思路。</p>
            <p class="tent">3.提供手动下单辅助函数：手动下单辅助函数编写的算法交易模型可接管手动委托，控制交易过程，可实现智能分批、滑点控制等策略。</p>
            <p class="tent">4.提供国内所有期货品种挂牌交易以来全部历史k线数据，以及五档委托价、委托量，买卖盘大单统计数据等全面的TICK数据，可供各类模型历史回测。</p>
            <p class="tent">5.支持在策略模型中直接写入算法交易策略，可细化信号处理机制，控制交易过程，可实现智能分批、滑点控制等策略。</p>
            <p class="tent">6.支持期权算法模型，可实现全市场实时监控，自动捕获期权各种套利机会。</p>
            <!-- <p class="tent">* 仅限使用wh9软件登录</p> -->
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <p class="tent"><a href="https://wt9.wenhua.com.cn/Order/Index" target="_blank">>>> 查看9B套餐量化交易更多功能</a></p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.购买前请先下载<a href="https://wt9.wenhua.com.cn/Download/index?flag=1" target="_blank">wh9</a>体验版了解软件基础功能。</p>
            <p class="tent">
                2.使用wh9的电脑配置要求：<br />
                · CPU：X86架构，4核及以上配置；<br />
                · 内存：要达到8G及以上；<br />
                · 操作系统：win10/win11/win_server2016，64位版本
            </p>
            <p class="tent">3.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            <p class="tent">4.使用授权账号登录后可选择文华支持的任意期货公司进行交易（<a target="_blank"  href="https://wt9.wenhua.com.cn/Jytd/Index">查看文华支持的期货公司名单</a>），但如以后因所开户的期货公司交易通道关闭，文华不负责解决并不退还剩余费用。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
    .details_gn{
        min-height: 255px;
    }
</style>